import React from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Grid,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const OfferLetterDetails = () => {
  const offerLetters = useSelector((state) => state?.jobs?.OfferLetters) || [];

  // Get latest offer letter
  const offer = offerLetters?.[0];

  if (!offer) {
    return (
      <Box >
        <Typography variant="body1" color="text.secondary">
          No offer letter data available.
        </Typography>
      </Box>
    );
  }

  return (
    <Box maxWidth={700} mx="auto" >
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6" fontWeight="bold">
            Offer Letter Details
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Designation
              </Typography>
              <Typography variant="body1">
                {offer.designation || "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="subtitle2" color="text.secondary">
                CTC
              </Typography>
              <Typography variant="body1">
                {offer.ctc || "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Date of Joining
              </Typography>
              <Typography variant="body1">
                {offer.date_of_joining || "N/A"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Status
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {offer.status || "Pending"}
              </Typography>
            </Grid>

            {offer.remarks && (
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">
                  Remarks
                </Typography>
                <Typography variant="body1">
                  {offer.remarks}
                </Typography>
              </Grid>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default OfferLetterDetails;
